<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm6 md2>
          <v-text-field
            disabled
            v-model="mycode"
            label=" رقم إذن السداد للخزينة"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            @keyup.enter="search_client_by_code"
            v-model="searchClientCode"
            label="كودالعميل"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-autocomplete
            v-model="select_client"
            :hint="
              `${
                select_client.mandob_sales
                  ? select_client.mandob_sales.name
                  : ''
              }- ${select_client.mohafza ? select_client.mohafza.name : ''}- ${
                select_client.city ? select_client.city.name : ''
              }- ${select_client.region ? select_client.region.name : ''}- ${
                select_client.branch ? select_client.branch.name : ''
              }`
            "
            :items="clients"
            item-text="name"
            item-value="id"
            label="أختر العميل"
            persistent-hint
            return-object
            single-line
            @change="get_all_info"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-autocomplete
            v-model="select_mandob"
            :items="mandobs"
            item-text="name"
            item-value="id"
            label="أختر مندوب التحصيل"
            persistent-hint
            return-object
            single-line
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-autocomplete
            v-model="select_khazna"
            :items="khazinas"
            item-text="name"
            item-value="id"
            label=" أختر الخزينة "
            persistent-hint
            return-object
            single-line
            @change="get_khazina"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            v-model="money"
            type="number"
            label="المبلغ"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            disabled
            v-model="madionia"
            label="المديونية"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-textarea v-model="comment" rows="2" label="ملاحظات"></v-textarea>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog2"
            v-model="modal2"
            :return-value.sync="date2"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date2"
                label=" التاريخ اليدوي"
                readonly
                outline
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date2" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialog2.save(date2)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-btn @click="add_sadad">Add</v-btn>
        </v-flex>
      </v-layout>
      <br />
      <p v-if="fatworas.length > 0">الفواتير الغير مسددة</p>
      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.price_after }}</td>
          <td class="text-xs-right">{{ props.item.remain }}</td>
          <td class="text-xs-right">{{ props.item.sdad_status }}</td>
          <td class="text-xs-right">{{ props.item.sdad_type_name }}</td>
          <td class="text-xs-right">{{ props.item.taslim_date }}</td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
          <td class="text-xs-right">{{ props.item.madionia_now }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير</div>

      <br />
      <p>مجموع السدادات بالنسبة لهذه الخزينة : {{ total }}</p>
      <p>
        مجموع السدادات بالنسبة لجميع الخزائن : {{ total_of_sadads_all_khaznas }}
      </p>

      <v-toolbar flat color="white">
        <v-toolbar-title> جميع السدادات السابقة</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>

      <v-data-table
        :headers="headers2"
        :items="sadads_fatworas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '0'
                ? { 'background-color': '#D4B1B1' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td class="text-xs-right">
              {{ props.item.client ? props.item.client.name : "" }}
            </td>
            <td>{{ props.item.money_q }}</td>
            <td>
              {{
                props.item.mandob_tahsil ? props.item.mandob_tahsil.name : ""
              }}
            </td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">
              <v-btn
                v-if="permissions.delete_all == 1 || user.type == 1"
                @click="delete_sadad(props.item)"
                >حذف</v-btn
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  search_client_by_code,
  khazina_client_sadads,
  khazna_fatworas,
  add_client_sadad,
  get_all_client_info,
  delete_client_sadad,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " الكود",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: " السعر", value: "address", sortable: false, align: "right" },
      { text: " المتبقي", value: "address", sortable: false, align: "right" },
      { text: " حالة السداد", value: "rasid", sortable: false, align: "right" },
      { text: " نوع السداد", value: "rasid", sortable: false, align: "right" },
      {
        text: "تاريخ التسليم",
        value: "taslim_date",
        sortable: false,
        align: "center"
      },
      {
        text: "التاريخ",
        value: "created_at",
        sortable: false,
        align: "center"
      },
      {
        text: "المديونية وقتها ",
        value: "control",
        sortable: false,
        align: "center"
      }
    ],
    headers2: [
      { text: "اسم العميل", value: "client.name", align: "right" },
      {
        text: " المبلغ",
        align: "right",
        value: "money_q"
      },
      {
        text: " مندوب التحصيل",
        align: "right",
        value: "money_q"
      },
      { text: "التاريخ", value: "created_at", align: "right" }
    ],
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    select_mandob: { id: "" },
    select_client: { id: "" },
    select_khazna: { id: "" },
    search: "",
    comment: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    khazina_fatworas: [],
    mandobs: [],
    clients: [],
    fatworas: [],
    khazinas: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    sadads_fatworas: [],
    total: "",
    money: "",
    searchClientCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: "",
    client_sadad_table1: {
      money_q: "",
      note: "",
      madionia_before: "",
      madionia_after: "",
      emp_name: "",
      emp_id: "",
      khazina_id: "",
      client_id: "",
      fatwora_clients_id: "",
      created_at: ""
    },
    client_sadad_table2: {
      money_q: "",
      note: "",
      madionia_before: "",
      madionia_after: "",
      emp_name: "",
      emp_id: "",
      khazina_id: "",
      client_id: "",
      fatwora_clients_id: "",
      created_at: ""
    },
    client_sadad_table3: {
      money_q: "",
      note: "",
      madionia_before: "",
      madionia_after: "",
      emp_name: "",
      emp_id: "",
      khazina_id: "",
      client_id: "",
      fatwora_clients_id: "",
      created_at: ""
    },
    khazna_fatwora_table: {
      code: "",
      emp_name: "",
      rasid_before: "",
      money: "",
      rasid_after: "",
      type: "",
      notes: "",
      khazina_id: "",
      action: "",
      created_at: ""
    },
    madionia_client_table: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      client_id: "",
      emp_id: "",
      created_at: ""
    },
    fatwora_client_update1: {
      id: "",
      remain: "",
      sdad_status: "",
      sdad_status_id: ""
    },
    fatwora_client_update2: {
      id: "",
      remain: "",
      sdad_status: "",
      sdad_status_id: ""
    },
    fatwora_client_update3: {
      id: "",
      remain: "",
      sdad_status: "",
      sdad_status_id: ""
    },
    khazina_update: {
      id: "",
      rasid: ""
    },
    madionia: 0,
    total_of_sadads_all_khaznas: 0
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas && this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      // clients().then(response => {
      //   this.clients = response.data;
      //
      // });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data.khazna_fatworas;
        this.clients = response.data.clients;
        this.mandobs = response.data.mandobs;
        this.loading = false;
      });
    },

    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_client = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.khazinas = [];
      this.fatworas = [];
      this.madionia = 0;
      this.total_of_sadads_all_khaznas = 0;
      this.madionia_sabqa = "";
      this.searchClientCode = this.select_client.code;
      this.loading = true;
      get_all_client_info(this.select_client.id).then(res => {
        this.khazinas = res.data.khazinas;
        this.fatworas = res.data.fatworas_no_sadad;
        this.madionia = res.data.madionia;
        this.total_of_sadads_all_khaznas = res.data.total_of_sadads_all_khaznas;
        // this.khasm_fatworas = res.data.khasm_fatworas;
        this.loading = false;
      });

      // khazinas(this.select_client.branch_id).then(response => {
      //   this.khazinas = response.data;
      // });

      // this.searchClientCode = this.select_client.code;
      // this.fatworas = [];
      // this.madionia_sabqa = "";
      // this.loading = true;
      // fatworas_client_no_sadad(this.select_client.id).then(response => {
      //   this.fatworas = response.data;
      //   this.loading = false;
      // });
      // madionia_client(this.select_client.id).then(response => {
      //   this.madionia_sabqa =
      //     parseFloat(response.data.madionia) +
      //     (response.data.client.rasid_efttahi != ""
      //       ? parseFloat(response.data.client.rasid_efttahi)
      //       : 0);
      //   this.madionia_sabqa_of_madionia =
      //     response.data.madionia != 0
      //       ? parseFloat(response.data.madionia)
      //       : 0;
      // });
    },
    get_khazina() {
      khazina_client_sadads(this.select_khazna.id).then(response => {
        this.theKhazna = response.data.khazina;
        this.sadads_fatworas = response.data.sadads;
        this.pagination.totalItems = response.data.sadads.length;
        this.total = response.data.total;
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    add_sadad() {
      if (
        this.select_client.id != "" &&
        this.money != "" &&
        this.select_khazna.id != ""
      ) {
        let myUser = JSON.parse(localStorage.getItem("user"));

        this.khazna_fatwora_table.code = this.mycode;
        this.khazna_fatwora_table.emp_name = myUser.name;
        this.khazna_fatwora_table.rasid_before = this.theKhazna.rasid;
        this.khazna_fatwora_table.money = this.money;
        this.khazna_fatwora_table.rasid_after =
          parseFloat(this.theKhazna.rasid) + parseFloat(this.money);
        this.khazna_fatwora_table.type = "in";
        this.khazna_fatwora_table.action = "client_sadad";
        this.khazna_fatwora_table.notes = this.comment;
        this.khazna_fatwora_table.khazina_id = this.select_khazna.id;
        this.khazna_fatwora_table.created_at = this.date2;

        this.madionia_client_table.madionia_before = this.madionia_sabqa_of_madionia;
        this.madionia_client_table.cost_or_money = this.money;
        this.madionia_client_table.madionia_after =
          parseFloat(this.madionia_sabqa_of_madionia) - parseFloat(this.money);
        this.madionia_client_table.emp_name = myUser.name;
        this.madionia_client_table.type_of_operation = "sadad";
        this.madionia_client_table.code_of_operation = this.khazna_fatwora_table.code;
        this.madionia_client_table.client_id = this.select_client.id;
        this.madionia_client_table.emp_id = myUser.id;
        this.madionia_client_table.created_at = this.date2;

        this.client_sadad_table1.note = this.comment;
        this.client_sadad_table1.madionia_before = this.madionia_sabqa;
        this.client_sadad_table1.emp_name = myUser.name;
        this.client_sadad_table1.emp_id = myUser.id;
        this.client_sadad_table1.khazina_id = this.select_khazna.id;
        this.client_sadad_table1.client_id = this.select_client.id;
        this.client_sadad_table1.created_at = this.date2;

        this.client_sadad_table2.note = this.comment;
        this.client_sadad_table2.emp_name = myUser.name;
        this.client_sadad_table2.emp_id = myUser.id;
        this.client_sadad_table2.khazina_id = this.select_khazna.id;
        this.client_sadad_table2.client_id = this.select_client.id;
        this.client_sadad_table2.created_at = this.date2;

        this.client_sadad_table3.note = this.comment;
        this.client_sadad_table3.emp_name = myUser.name;
        this.client_sadad_table3.emp_id = myUser.id;
        this.client_sadad_table3.khazina_id = this.select_khazna.id;
        this.client_sadad_table3.client_id = this.select_client.id;
        this.client_sadad_table3.created_at = this.date2;

        this.khazina_update.id = this.theKhazna.id;
        this.khazina_update.rasid =
          parseFloat(this.theKhazna.rasid) + parseFloat(this.money);
        if (this.fatworas.length > 0) {
          if (parseFloat(this.money) >= parseFloat(this.fatworas[0].remain)) {
            if (this.fatworas[1]) {
              if (
                parseFloat(this.money) >=
                parseFloat(this.fatworas[0].remain) +
                  parseFloat(this.fatworas[1].remain)
              ) {
                if (this.fatworas[2]) {
                  // client sadad array[0]
                  var remain_to_second_fatwora =
                    parseFloat(this.money) -
                    parseFloat(this.fatworas[0].remain);
                  this.client_sadad_table1.fatwora_clients_id = this.fatworas[0].id;
                  this.client_sadad_table1.money_q = this.fatworas[0].remain;
                  this.client_sadad_table1.madionia_after =
                    parseFloat(this.madionia_sabqa) -
                    parseFloat(this.fatworas[0].remain);
                  // this.push_client_sadad(this.client_sadad_table)
                  this.all_client_sadads[0] = this.client_sadad_table1;

                  // client sadad array[1]
                  var remain_to_third_fatwora =
                    parseFloat(remain_to_second_fatwora) -
                    parseFloat(this.fatworas[1].remain);
                  this.client_sadad_table2.fatwora_clients_id = this.fatworas[1].id;
                  this.client_sadad_table2.madionia_before = this.client_sadad_table1.madionia_after;
                  this.client_sadad_table2.money_q = this.fatworas[1].remain;
                  this.client_sadad_table2.madionia_after =
                    this.client_sadad_table1.madionia_after -
                    parseFloat(this.fatworas[1].remain);
                  // this.all_client_sadads.push(client_sadad_table2)
                  this.all_client_sadads[1] = this.client_sadad_table2;

                  // client sadad array[2]
                  this.client_sadad_table3.fatwora_clients_id = this.fatworas[2].id;
                  this.client_sadad_table3.madionia_before = this.client_sadad_table2.madionia_after;
                  this.client_sadad_table3.money_q = remain_to_third_fatwora;
                  this.client_sadad_table3.madionia_after =
                    this.client_sadad_table2.madionia_after -
                    parseFloat(remain_to_third_fatwora);
                  // this.all_client_sadads.push(client_sadad_table2)
                  this.all_client_sadads[2] = this.client_sadad_table3;

                  // fatwora client array[0]
                  this.fatwora_client_update1.id = this.fatworas[0].id;
                  this.fatwora_client_update1.remain = "0";
                  this.fatwora_client_update1.sdad_status = "تم السداد";
                  this.fatwora_client_update1.sdad_status_id = "3";
                  this.all_client_fatworas.push(this.fatwora_client_update1);

                  // fatwora client array[1]
                  this.fatwora_client_update2.id = this.fatworas[1].id;
                  this.fatwora_client_update2.remain = "0";
                  this.fatwora_client_update2.sdad_status = "تم السداد";
                  this.fatwora_client_update2.sdad_status_id = "3";
                  this.all_client_fatworas.push(this.fatwora_client_update2);

                  // fatwora client array[2]
                  this.fatwora_client_update3.id = this.fatworas[2].id;
                  this.fatwora_client_update3.remain =
                    parseFloat(this.fatworas[1].remain) -
                    parseFloat(remain_to_third_fatwora);
                  this.fatwora_client_update3.sdad_status = "جاري السداد";
                  this.fatwora_client_update3.sdad_status_id = "2";
                  this.all_client_fatworas.push(this.fatwora_client_update3);

                  let khazna_fatwora_ = JSON.stringify(
                    this.khazna_fatwora_table
                  );
                  let madionia_client_ = JSON.stringify(
                    this.madionia_client_table
                  );
                  let client_sadad_ = JSON.stringify(this.all_client_sadads);
                  let client_fatworas_ = JSON.stringify(
                    this.all_client_fatworas
                  );
                  let khazina_ = JSON.stringify(this.khazina_update);

                  this.do_sadad(
                    khazna_fatwora_,
                    madionia_client_,
                    client_sadad_,
                    client_fatworas_,
                    khazina_
                  );
                } else {
                  // client sadad array[0]
                  var remain_to_second_fatwora =
                    parseFloat(this.money) -
                    parseFloat(this.fatworas[0].remain);
                  this.client_sadad_table1.fatwora_clients_id = this.fatworas[0].id;
                  this.client_sadad_table1.money_q = this.fatworas[0].remain;
                  this.client_sadad_table1.madionia_after =
                    parseFloat(this.madionia_sabqa) -
                    parseFloat(this.fatworas[0].remain);
                  // this.push_client_sadad(this.client_sadad_table)
                  this.all_client_sadads[0] = this.client_sadad_table1;

                  // client sadad array[1]
                  this.client_sadad_table2.fatwora_clients_id = this.fatworas[1].id;
                  this.client_sadad_table2.madionia_before = this.client_sadad_table1.madionia_after;
                  this.client_sadad_table2.money_q = remain_to_second_fatwora;
                  this.client_sadad_table2.madionia_after =
                    this.client_sadad_table1.madionia_after -
                    parseFloat(remain_to_second_fatwora);
                  // this.all_client_sadads.push(client_sadad_table2)
                  this.all_client_sadads[1] = this.client_sadad_table2;

                  // fatwora client array[0]
                  this.fatwora_client_update1.id = this.fatworas[0].id;
                  this.fatwora_client_update1.remain = "0";
                  this.fatwora_client_update1.sdad_status = "تم السداد";
                  this.fatwora_client_update1.sdad_status_id = "3";
                  this.all_client_fatworas.push(this.fatwora_client_update1);

                  // fatwora client array[1]
                  this.fatwora_client_update2.id = this.fatworas[1].id;
                  this.fatwora_client_update2.remain =
                    parseFloat(this.fatworas[1].remain) -
                    parseFloat(remain_to_second_fatwora);
                  this.fatwora_client_update2.sdad_status = "تم السداد";
                  this.fatwora_client_update2.sdad_status_id = "3";
                  this.all_client_fatworas.push(this.fatwora_client_update2);

                  let khazna_fatwora_ = JSON.stringify(
                    this.khazna_fatwora_table
                  );
                  let madionia_client_ = JSON.stringify(
                    this.madionia_client_table
                  );
                  let client_sadad_ = JSON.stringify(this.all_client_sadads);
                  let client_fatworas_ = JSON.stringify(
                    this.all_client_fatworas
                  );
                  let khazina_ = JSON.stringify(this.khazina_update);

                  this.do_sadad(
                    khazna_fatwora_,
                    madionia_client_,
                    client_sadad_,
                    client_fatworas_,
                    khazina_
                  );
                }
              } else {
                // mean is more than first but least than addition 1 + 2 so send twice

                // client sadad array[0]
                var remain_to_second_fatwora =
                  parseFloat(this.money) - parseFloat(this.fatworas[0].remain);
                this.client_sadad_table1.fatwora_clients_id = this.fatworas[0].id;
                this.client_sadad_table1.money_q = this.fatworas[0].remain;
                this.client_sadad_table1.madionia_after =
                  parseFloat(this.madionia_sabqa) -
                  parseFloat(this.fatworas[0].remain);
                // this.push_client_sadad(this.client_sadad_table)
                this.all_client_sadads[0] = this.client_sadad_table1;

                // client sadad array[1]
                this.client_sadad_table2.fatwora_clients_id = this.fatworas[1].id;
                this.client_sadad_table2.madionia_before = this.client_sadad_table1.madionia_after;
                this.client_sadad_table2.money_q = remain_to_second_fatwora;
                this.client_sadad_table2.madionia_after =
                  this.client_sadad_table1.madionia_after -
                  parseFloat(remain_to_second_fatwora);
                // this.all_client_sadads.push(client_sadad_table2)
                this.all_client_sadads[1] = this.client_sadad_table2;

                // fatwora client array[0]
                this.fatwora_client_update1.id = this.fatworas[0].id;
                this.fatwora_client_update1.remain = "0";
                this.fatwora_client_update1.sdad_status = "تم السداد";
                this.fatwora_client_update1.sdad_status_id = "3";
                this.all_client_fatworas.push(this.fatwora_client_update1);

                // fatwora client array[1]
                this.fatwora_client_update2.id = this.fatworas[1].id;
                this.fatwora_client_update2.remain =
                  parseFloat(this.fatworas[1].remain) -
                  parseFloat(remain_to_second_fatwora);
                this.fatwora_client_update2.sdad_status = "جاري السداد";
                this.fatwora_client_update2.sdad_status_id = "2";
                this.all_client_fatworas.push(this.fatwora_client_update2);

                let khazna_fatwora_ = JSON.stringify(this.khazna_fatwora_table);
                let madionia_client_ = JSON.stringify(
                  this.madionia_client_table
                );
                let client_sadad_ = JSON.stringify(this.all_client_sadads);
                let client_fatworas_ = JSON.stringify(this.all_client_fatworas);
                let khazina_ = JSON.stringify(this.khazina_update);

                this.do_sadad(
                  khazna_fatwora_,
                  madionia_client_,
                  client_sadad_,
                  client_fatworas_,
                  khazina_
                );
              }
            } else {
              if (
                parseFloat(this.money) == parseFloat(this.fatworas[0].remain)
              ) {
                // client sadad array[0]
                var remain_to_first_fatwora =
                  parseFloat(this.fatworas[0].remain) - parseFloat(this.money);
                this.client_sadad_table1.fatwora_clients_id = this.fatworas[0].id;
                this.client_sadad_table1.money_q = this.money;
                this.client_sadad_table1.madionia_after =
                  parseFloat(this.madionia_sabqa) - parseFloat(this.money);
                // this.push_client_sadad(this.client_sadad_table)
                this.all_client_sadads[0] = this.client_sadad_table1;

                // fatwora client array[0]
                this.fatwora_client_update1.id = this.fatworas[0].id;
                this.fatwora_client_update1.remain = remain_to_first_fatwora;
                this.fatwora_client_update1.sdad_status = "تم السداد";
                this.fatwora_client_update1.sdad_status_id = "3";
                this.all_client_fatworas.push(this.fatwora_client_update1);

                let khazna_fatwora_ = JSON.stringify(this.khazna_fatwora_table);
                let madionia_client_ = JSON.stringify(
                  this.madionia_client_table
                );
                let client_sadad_ = JSON.stringify(this.all_client_sadads);
                let client_fatworas_ = JSON.stringify(this.all_client_fatworas);
                let khazina_ = JSON.stringify(this.khazina_update);

                this.do_sadad(
                  khazna_fatwora_,
                  madionia_client_,
                  client_sadad_,
                  client_fatworas_,
                  khazina_
                );
              } else {
                // client sadad array[0]
                var remain_to_first_fatwora =
                  parseFloat(this.fatworas[0].remain) - parseFloat(this.money);
                this.client_sadad_table1.fatwora_clients_id = this.fatworas[0].id;
                this.client_sadad_table1.money_q = this.money;
                this.client_sadad_table1.madionia_after =
                  parseFloat(this.madionia_sabqa) - parseFloat(this.money);
                // this.push_client_sadad(this.client_sadad_table)
                this.all_client_sadads[0] = this.client_sadad_table1;

                // fatwora client array[0]
                this.fatwora_client_update1.id = this.fatworas[0].id;
                this.fatwora_client_update1.remain = remain_to_first_fatwora;
                this.fatwora_client_update1.sdad_status = "جاري السداد";
                this.fatwora_client_update1.sdad_status_id = "2";
                this.all_client_fatworas.push(this.fatwora_client_update1);

                let khazna_fatwora_ = JSON.stringify(this.khazna_fatwora_table);
                let madionia_client_ = JSON.stringify(
                  this.madionia_client_table
                );
                let client_sadad_ = JSON.stringify(this.all_client_sadads);
                let client_fatworas_ = JSON.stringify(this.all_client_fatworas);
                let khazina_ = JSON.stringify(this.khazina_update);

                this.do_sadad(
                  khazna_fatwora_,
                  madionia_client_,
                  client_sadad_,
                  client_fatworas_,
                  khazina_
                );
              }
            }
          } else {
            // client sadad array[0]
            var remain_to_first_fatwora =
              parseFloat(this.fatworas[0].remain) - parseFloat(this.money);
            this.client_sadad_table1.fatwora_clients_id = this.fatworas[0].id;
            this.client_sadad_table1.money_q = this.money;
            this.client_sadad_table1.madionia_after =
              parseFloat(this.madionia_sabqa) - parseFloat(this.money);
            // this.push_client_sadad(this.client_sadad_table)
            this.all_client_sadads[0] = this.client_sadad_table1;

            // fatwora client array[0]
            this.fatwora_client_update1.id = this.fatworas[0].id;
            this.fatwora_client_update1.remain = remain_to_first_fatwora;
            this.fatwora_client_update1.sdad_status = "جاري السداد";
            this.fatwora_client_update1.sdad_status_id = "2";
            this.all_client_fatworas.push(this.fatwora_client_update1);

            let khazna_fatwora_ = JSON.stringify(this.khazna_fatwora_table);
            let madionia_client_ = JSON.stringify(this.madionia_client_table);
            let client_sadad_ = JSON.stringify(this.all_client_sadads);
            let client_fatworas_ = JSON.stringify(this.all_client_fatworas);
            let khazina_ = JSON.stringify(this.khazina_update);

            this.do_sadad(
              khazna_fatwora_,
              madionia_client_,
              client_sadad_,
              client_fatworas_,
              khazina_
            );
          }
        } else {
          if (parseFloat(this.madionia) > 0) {
            if (parseFloat(this.money) > parseFloat(this.madionia)) {
              alert("قيمة السداد اكبر من المديونية ");
            } else {
              let khazna_fatwora_ = JSON.stringify(this.khazna_fatwora_table);
              let madionia_client_ = JSON.stringify(this.madionia_client_table);
              let client_sadad_ = JSON.stringify(this.all_client_sadads);
              let khazina_ = JSON.stringify(this.khazina_update);

              this.do_sadad(
                khazna_fatwora_,
                madionia_client_,
                client_sadad_,
                null,
                khazina_
              );
            }
          } else {
            alert("المديونية صفر ولا يمكن عمل سداد للعميل هذا ");
          }
        }
      }
    },
    do_sadad(
      khazna_fatwora_,
      madionia_client_,
      client_sadad_,
      client_fatworas_,
      khazina_
    ) {
      this.loading = true;
      var frmData = new FormData();
      frmData.append("khazna_fatwora_table", khazna_fatwora_);
      frmData.append("madionia_client_table", madionia_client_);
      frmData.append("all_client_sadads", client_sadad_);
      frmData.append("all_client_fatworas", client_fatworas_);
      frmData.append("khazina_table", khazina_);
      frmData.append("mandob_id", this.select_mandob.id);
      frmData.append("client_id", this.select_client.id);
      add_client_sadad(frmData).then(response => {
        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", "سداد عميل");
        frmData3.append(
          "body",
          " -تم سداد المديونية لعميل بكود -" +
            this.select_client.code +
            "- بواسطة -" +
            myUser.name +
            "- قيمتها -" +
            this.money +
            " -"
        );
        frmData3.append("type", "client_sadad");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = " سداد عميل";
            let mybody =
              " - تم سداد المديونية لعميل بكود -" +
              this.select_client.code +
              "-واسمه -" +
              this.select_client.name +
              "-قيمتها -" +
              this.money +
              "- بواسطة -" +
              myUser.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }
        });
        setTimeout(() => {
          this.$router.go(0);
        }, 2000);
        this.loading = false;
      });
    },
    delete_sadad(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.sadads_fatworas.indexOf(item);

          this.loading = true;

          delete_client_sadad(item.id).then(response => {
            this.loading = false;
            this.sadads_fatworas.splice(index, 1);
            this.close();
            this.$router.go(0);
          });
        }
      });
    },
    push_client_sadad(sadad) {
      this.all_client_sadads.push(sadad);
    },
    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          this.newItem.code = this.code;
          this.newItem.branch_id = this.select_branch.id;
          var frmData = new FormData();
          frmData.append("bank", JSON.stringify(this.newItem));

          add_bank(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_branch, this.$options.data().select_branch);

            this.banks.push(response.data);
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$router.go(0);
            }, 3000);
          });
        }
      });
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let item_id = this.editedItem.id;

          this.editedItem.branch_id = this.select_branch_edit.id;
          var frmData = new FormData();
          frmData.append("bank", JSON.stringify(this.editedItem));
          update_bank(frmData, item_id).then(response => {
            Vue.set(
              this.banks,
              this.banks.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
